<template>
  <div class="bgf5">
    <iHeader />
    <iNav />
    <iClassify :active="3" AllActive />
    <iRightFixedBox />
    <!-- 页面中间内容 -->
    <div class="page-content">
      <div class="head-box" v-if="isComplete">
        <div class="content">
			<div class="content_title">
				<div class="dis">以下商品可参加:</div>
				<div class="date">
				  活动时间 {{ CountDownBeginTime }}-{{ CountDownEndTime }}
				</div>
			</div>
          
		  <div class="dis">
			  {{ activeTips }}
		  </div>
        </div>
      </div>
      <div class="body-box" v-if="isComplete && goodsList.length">
        <div class="nav-top">
          <div class="menu-head">
            <div
              class="btn-box"
              :class="{ active: navType == 1 }"
              @click.stop="navClick(1)"
            >
              <span>综合</span>
              <span class="iconfont iconzonghe tag-icon"></span>
            </div>
            <div
              class="btn-box"
              :class="{ active: navType == 2 }"
              @click.stop="navClick(2)"
            >
              <span>价格</span>
              <span
                class="iconfont iconqiehuan tag-icon"
                v-if="navType != 2"
              ></span>
              <img
                src="@/assets/public/p-down.png"
                class="up-dowm-icon"
                v-if="IsPirceSort == 1 && navType == 2"
                alt=""
              />
              <img
                src="@/assets/public/p-up.png"
                class="up-dowm-icon"
                v-if="IsPirceSort == 2 && navType == 2"
                alt=""
              />
            </div>
            <div
              class="btn-box"
              :class="{ active: navType == 3 }"
              @click.stop="navClick(3)"
            >
              <span>销量</span>
              <span
                class="iconfont iconqiehuan tag-icon"
                v-if="navType != 3"
              ></span>
              <img
                src="@/assets/public/p-down.png"
                class="up-dowm-icon"
                v-if="SalesVolumeSort == 1 && navType == 3"
                alt=""
              />
              <img
                src="@/assets/public/p-up.png"
                class="up-dowm-icon"
                v-if="SalesVolumeSort == 2 && navType == 3"
                alt=""
              />
            </div>
          </div>
        </div>
        <div class="goods-content">
          <div
            class="goods-item"
            v-for="(item, index) in goodsList"
            :key="index"
            @click.stop="toGoodsDetail(item)"
          >
            <special-goods-item
              :product="item"
              :showParams="true"
              :timer="item.timer"
              :tags="activityInfo.ActivityTags"
              :countdownType="activityInfo.countdownType"
              :showGoodsTime="activityInfo.ShowGoodsTime === 2"
              :IsOpenPreActivity="activityInfo.IsOpenPreActivity"
              :ConfigType="activityInfo.ConfigType"
            />
            <!-- <iProductDetail
              :product="_itemToGoods(goods)"
              :ActivityTags="ActivityTags"
              :ref="'p_' + goods.Id"
              fromPage="AlwaysBuysList"
              :timeOut="changeTimeOut(goods.GoodsActivityCountdown)"
              :ShowGoodsTime="!!goods.GoodsActivityCountdown"
            /> -->
          </div>
          <div class="paging">
            <iPagination
              :currentPage.sync="pageindex"
              :limit.sync="pageSize"
              :totalCount="totalCount"
              @turn="onLoad"
              small
            />
          </div>
        </div>
      </div>
      <div class="empty-box" v-if="isComplete && !goodsList.length">
        <EmptyControl
          style="background:none"
          type="goods"
          text="该活动没有商品~~"
        ></EmptyControl>
      </div>
    </div>
    <iFooter />
  </div>
</template>

<script>
import iHeader from '@/components/Header'
import iNav from '@/components/Nav'
import iClassify from '@/components/Classify'
import iFooter from '@/components/Footer'
import iProductDetail from '@/components/ProductDetail'
import iRightFixedBox from '@/components/RightFixedBox'
import iPagination from '@/components/iPagination'
import SpecialGoodsItem from '@/components/SpecialGoodsItem.vue'
import { BaseMixin } from '../../mixins/BaseMixin'
export default {
  name: 'ActivityProductList',
  mixins: [BaseMixin],
  components: {
    iHeader,
    iNav,
    iClassify,
    iFooter,
    iProductDetail,
    iRightFixedBox,
    iPagination,
    SpecialGoodsItem,
  },
  data() {
    return {
      activeTips: '',
      CountDownBeginTime: '',
      CountDownEndTime: '',
      isComplete: false, // 页面加载是否完成
      Id: '', // 活动ID
      IsPirceSort: 1, // 价格排序 1升序，2降序
      SalesVolumeSort: 1, // 销量排序 1升序，2降序
      pageindex: 1, // 分页页码
      pageSize: 10, // 每页条数
      totalCount: 100, // 商品总条数
      navType: 1, // 导航选中状态 1综合 2价格 3销量
      goodsList: [], // 商品数据
      activityInfo: {
        // 活动信息
        Configs: [],
      },
    }
  },
  created() {
    const { str = '' } = this.$route.query
    this.activeTips = str
    this.Id = this.$route.query.id
    this.getActivityInfo()
    this.getInfo()
  },
  methods: {
    changeTimeOut(data) {
      let result = {}
      if (data) {
        result = {
          Day: data.Days,
          time: data.TotalMilliseconds,
          IsWillBegin: data.countdownType,
        }
      }

      return result
    },
    // 获取活动的信息
    async getActivityInfo() {
      let res = await this.getAction(
        '/api_promotions/SalesPromotion/GetActivityInfoByActivityId',
        { activityId: this.Id }
      )
      if (res.IsSuccess) {
        this.activityInfo = res.Data
        this.CountDownBeginTime = res.Data.BeginTime
        this.CountDownEndTime = res.Data.EndTime
        this.ActivityTags = res.Data.ActivityTags
        this.ConfigType = res.Data.ConfigType
      }
    },
    // 跳转到商品详情
    toGoodsDetail(item) {
      this._jump(
        this.Enum_LinkTypeCode.ProductDetails,
        {
          id: item.Id,
          detailType: 'specialOffer',
          configType: this.activityInfo.ConfigType,
        },
        '_blank'
      )
    },
    // 点击列表筛选条件
    navClick(val) {
      this.navType = val
      // 价格
      if (val == 2) {
        if (this.IsPirceSort == 2) {
          this.IsPirceSort = 1
        } else {
          this.IsPirceSort = 2
        }
      }
      // 销量
      if (val == 3) {
        if (this.SalesVolumeSort == 2) {
          this.SalesVolumeSort = 1
        } else {
          this.SalesVolumeSort = 2
        }
      }
      this.pageindex = 1
      this.getInfo()
    },
    // 触发分页
    onLoad() {
      this.getInfo()
    },
    // 查询活动商品信息
    async getInfo() {
      // 请求参数
      let params = {
        Id: this.Id,
        pageNo: this.pageindex,
        pageSize: this.pageSize,
        IsPirceSort: this.navType == 2 ? this.IsPirceSort : 0,
        IsDefalutSort: this.navType == 1,
        SalesVolumeSort: this.navType == 3 ? this.SalesVolumeSort : 0,
      }
      let res = await this.postAction(
        '/api_promotions/SalesPromotion/GetCustomerActivityGoodsList',
        params
      )
      if (res.IsSuccess) {
        res.Data.forEach((el) => {
          el.img = el.Logo
          el.name = el.SkuName
        })
        this.goodsList = res.Data
        this.totalCount = res.Count
      }
      // 接口已请求完成
      this.isComplete = true
    },
  },
}
</script>

<style scoped lang="less">
.page-content {
  min-height: 600px;
  text-align: left;
  .head-box {
    width: 100%;
    background: #ff3939;
    .content {
      width: 1200px;
      margin: auto;
      padding: 12px 0;
      color: #fff;
	  .content_title{
		  display: flex;
		  justify-content: space-between;
	  }
      .dis {
        font-size: 16px;
      }
      .date {
        font-size: 14px;
      }
    }
  }
  .body-box {
    width: 1200px;
    margin: auto;
    .goods-content {
      display: flex;
      flex-wrap: wrap;
      margin: -8px;
      padding-bottom: 97px;
      .goods-item {
        width: 20%;
        padding: 8px;
        box-sizing: border-box;
      }
    }
    .nav-top {
      padding: 16px 0;
      .menu-head {
        display: flex;
      }
      .tag-icon {
        font-size: 16px;
        margin-left: 2px;
      }
      color: #111a34;
      .btn-icon {
        width: 14px;
        height: 14px;
        vertical-align: top;
        margin-left: 4px;
      }
      .btn-box {
        width: 117px;
        height: 30px;
        background: #ffffff;
        border-radius: 2px 0px 0px 2px;
        border: 1px solid #c5cad5;
        border-right: 0;
        line-height: 30px;
        display: flex;
        align-items: center;
        justify-content: center;
        cursor: pointer;
        &:hover {
          color: #0f6eea;
        }
      }
      .active {
        background: #0f6eea;
        color: #fff;
        border: 1px solid #0f6eea;
        &:hover {
          color: #fff;
        }
      }
      .btn-box:last-child {
        border-right: 1px solid #c5cad5;
      }
    }
  }
}
.paging {
  width: 100%;
  display: flex;
  justify-content: center;
}
.empty-box {
  padding: 100px 0;
}
.up-dowm-icon {
  width: 16px;
  height: 16px;
  margin-left: 2px;
}
</style>
